'use client';

import { faXmark } from '@fortawesome/pro-light-svg-icons';
import { faCircleExclamation } from '@fortawesome/pro-solid-svg-icons';
import { DataTestIdEnum } from '@medprev-web-app/datatestid';

import { Icon } from '@/components/ui/icon.component';
import { Link } from '@/components/ui/link/link.component';
import { dismissOpenPaymentsNotice } from '@/store/open-payments/open-payments.store';
import { OpenPaymentsOrigin } from '@/types/enums/analytics/open-payments/open-payments-analytics.enum';
import { buildOpenPaymentsLink } from '@/utils/consts/open-payments.consts';

export function OpenPaymentsNoticeContent() {
  return (
    <>
      <Icon
        icon={faCircleExclamation}
        className="size-6 shrink-0 text-warning-600"
        aria-hidden="true"
      />

      <p className="flex-1 text-base font-bold leading-6 text-warning-800">
        Você possui pagamentos em aberto.
        {' '}
        <Link
          href={buildOpenPaymentsLink(OpenPaymentsOrigin.NOTICE)}
          className="font-semibold underline"
          data-testid={DataTestIdEnum.OPEN_PAYMENTS_NOTICE_LINK}
        >
          Ver pagamentos
        </Link>
      </p>

      <button
        type="button"
        aria-label="Fechar aviso de pagamentos em aberto"
        className="shrink-0"
        data-testid={DataTestIdEnum.OPEN_PAYMENTS_NOTICE_DISMISS_BUTTON}
        onClick={dismissOpenPaymentsNotice}
      >
        <Icon icon={faXmark} className="size-5 text-warning-700" aria-hidden="true" />
      </button>
    </>
  );
}
